const config = {
    GOOGLE_AUTH_CLIENT_ID: process.env.REACT_APP_GAUTH_KEY,
    API_BASE_URL: process.env.REACT_APP_BASE_URL || 'http://localhost:3002',
    GOOGLE_MAPS_KEY: process.env.REACT_APP_MAPS_KEY,
    FIREBASE: {
        apiKey: 'AIzaSyDq337_MnOAVKZ4_BsBbl6YUyXnGo_6J8o',
        authDomain: 'bnb-pluck.firebaseapp.com',
        databaseURL: 'https://bnb-pluck.firebaseio.com',
        projectId: 'bnb-pluck',
        storageBucket: 'bnb-pluck.appspot.com',
        messagingSenderId: '843277070184',
    }
}

export default config;
